import { motion } from "framer-motion";
import { twMerge } from "tailwind-merge";

import type { IConcreteEffectProps } from "../types.js";

import { Animatable } from "./Animatable";

export function RevealDown({
  ease,
  active,
  duration,
  children,
  className,
  keepAlive,
}: IConcreteEffectProps) {
  return (
    <Animatable active={active} keepAlive={keepAlive}>
      <motion.div
        key="revealDown"
        className={twMerge("overflow-hidden", className)}
        initial={{ height: 0, opacity: 0 }}
        animate={
          active ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }
        }
        exit={{ height: 0, opacity: 0 }}
        transition={{ duration: duration ?? 0.2, ease: ease ?? "easeOut" }}>
        {children}
      </motion.div>
    </Animatable>
  );
}
